export function BuildCoursesIcon() {
	return (
		<svg
			width="100"
			height="100"
			viewBox="0 0 100 100"
			fill="none"
			className="item-icon"
			xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_267_1553)">
				<mask
					id="mask0_267_1553"
					maskUnits="userSpaceOnUse"
					x="0"
					y="0"
					width="100"
					height="100">
					<path d="M0.75 0.75H99.25V99.25H0.75V0.75Z" fill="white" />
				</mask>
				<g mask="url(#mask0_267_1553)">
					<mask
						id="mask1_267_1553"
						maskUnits="userSpaceOnUse"
						x="0"
						y="0"
						width="100"
						height="100">
						<path
							d="M50 0.75C22.8021 0.75 0.75 22.8021 0.75 50C0.75 77.1979 22.8021 99.25 50 99.25C77.1979 99.25 99.25 77.1979 99.25 50C99.25 22.8021 77.1979 0.75 50 0.75Z"
							fill="white"
						/>
					</mask>
					<g mask="url(#mask1_267_1553)">
						<path d="M0.75 0.75H99.25V99.25H0.75V0.75Z" fill="#F6AA3A" />
					</g>
				</g>
				<path
					d="M70.151 51.3751C68.8073 52.7866 67.2604 53.9272 65.5156 54.797C63.7708 55.6616 61.9271 56.2032 59.9896 56.422L54.3125 57.2136C52.4948 57.4688 50.7708 58.0053 49.1302 58.823C47.4896 59.6355 46.026 60.6928 44.7292 61.9897L44.0625 62.6563L35.5938 54.1876L36.2604 53.5209C37.5521 52.2136 38.6042 50.7397 39.4115 49.0938C40.2187 47.448 40.7448 45.7136 40.9948 43.8959L41.7865 38.2188C42.4479 31.948 46.9375 25.922 54.0104 24.1147C59.5156 22.7032 65.6615 24.1043 69.8698 28.3074C76.0729 34.5157 76.25 44.9532 70.151 51.3751Z"
					fill="white"
				/>
				<mask
					id="mask2_267_1553"
					maskUnits="userSpaceOnUse"
					x="19"
					y="58"
					width="21"
					height="21">
					<path d="M19.8385 58.6667H40V78.8542H19.8385V58.6667Z" fill="white" />
				</mask>
				<g mask="url(#mask2_267_1553)">
					<path
						d="M26.7552 61.2241L21.4844 66.495L21.8489 66.5366C22.1719 66.5679 22.4635 66.6877 22.7187 66.8908C22.9739 67.0939 23.1562 67.3491 23.2656 67.6564C23.375 67.9637 23.3906 68.2762 23.3177 68.5939C23.2448 68.9116 23.0937 69.1877 22.8646 69.4168C21.5312 70.7502 20.7396 72.3543 20.4948 74.2241L19.8542 79.1408L22.0364 76.9585C23.6927 75.3022 26.5208 76.4741 26.5208 78.8179C26.5208 78.8283 29.026 76.3075 29.0156 76.3179C29.2552 76.0783 29.5469 75.922 29.8802 75.8543C30.2187 75.7918 30.5417 75.8231 30.8594 75.9533C31.1771 76.0835 31.4323 76.2918 31.6198 76.5783C31.8125 76.8595 31.9062 77.1772 31.9062 77.5158L37.5 71.922C37.9792 71.4429 38.3542 70.8856 38.6146 70.2606C38.875 69.6304 39.0052 68.9741 39.0052 68.2918C39.0052 67.6147 38.875 66.9585 38.6146 66.3283C38.3542 65.7033 37.9792 65.146 37.5 64.6668L34.0625 61.2293C33.5781 60.745 33.0208 60.3752 32.3854 60.1147C31.7552 59.8543 31.0937 59.7241 30.4114 59.7241C29.7239 59.7241 29.0677 59.8491 28.4323 60.1095C27.8021 60.37 27.2396 60.745 26.7552 61.2241Z"
						fill="white"
					/>
				</g>
				<path
					d="M35.6927 63.0105C35.4219 62.7397 35.1094 62.5313 34.7552 62.3855C34.4063 62.2397 34.0365 62.1667 33.6563 62.1667C33.2708 62.1667 32.9063 62.2397 32.5521 62.3855C32.1979 62.5313 31.8906 62.7397 31.6198 63.0105C30.7761 63.849 30.2656 64.8595 30.0833 66.0313L29.6146 69.0938L32.6719 68.6251C33.8438 68.4428 34.8542 67.9324 35.6927 67.0938C35.9636 66.823 36.1719 66.5105 36.3177 66.1563C36.4636 65.8022 36.5365 65.4324 36.5365 65.0522C36.5365 64.6667 36.4636 64.3022 36.3177 63.948C36.1719 63.5938 35.9636 63.2813 35.6927 63.0105Z"
					fill="white"
				/>
				<mask
					id="mask3_267_1553"
					maskUnits="userSpaceOnUse"
					x="42"
					y="38"
					width="38"
					height="33">
					<path
						d="M42.6667 38.6667H79.8385V70.6667H42.6667V38.6667Z"
						fill="white"
					/>
				</mask>
				<g mask="url(#mask3_267_1553)">
					<path
						d="M44.4167 69.9325L43.8385 69.3595L44.4167 68.7814L44.9948 69.3595L44.4167 69.9325ZM45.9531 68.396L45.375 67.8179L45.9531 67.245L46.526 67.8179L45.9531 68.396ZM47.4948 66.8595L46.9219 66.2814L47.4948 65.7085L48.0729 66.2814L47.4948 66.8595ZM49.0312 65.3543L48.4844 64.745C48.6927 64.5575 48.9114 64.3804 49.1354 64.2033L49.6354 64.8439C49.4219 65.0106 49.2187 65.1825 49.0208 65.3543H49.0312ZM50.7135 64.1095L50.2969 63.4116C50.5312 63.271 50.7812 63.1304 51.0312 63.0054L51.401 63.7293C51.1614 63.8491 50.9323 63.9741 50.7083 64.1095H50.7135ZM52.5937 63.1929L52.3073 62.4325C52.5677 62.3335 52.8333 62.2397 53.1042 62.1564L53.3385 62.9377C53.0885 63.0158 52.8385 63.0991 52.5937 63.1929ZM54.6146 62.6304L54.4687 61.8335C54.7656 61.7814 54.9583 61.7554 55.2917 61.7085L55.401 62.5158C55.0364 62.5627 54.875 62.5835 54.6146 62.6304ZM56.75 62.3231L56.6354 61.5158L57.4427 61.4064L57.5521 62.2137L56.75 62.3231ZM58.9062 62.0262L58.7917 61.2085L59.5989 61.0991L59.7135 61.9064L58.9062 62.0262ZM61.0521 61.7345L60.9427 60.922C61.2031 60.8908 61.4687 60.8491 61.7292 60.8075L61.8646 61.6095C61.5989 61.6564 61.3229 61.6981 61.0469 61.7345H61.0521ZM63.2239 61.3335L63.0364 60.5366C63.2969 60.4793 63.5573 60.4116 63.8125 60.3387L64.0312 61.12C63.7656 61.1981 63.4948 61.2658 63.2292 61.3335H63.2239ZM65.3489 60.7085L65.0781 59.9377C65.3281 59.8543 65.5833 59.7606 65.8281 59.6668L66.125 60.4272C65.8698 60.521 65.6094 60.6095 65.3542 60.7085H65.3489ZM67.401 59.8752L67.0521 59.1356C67.2917 59.0262 67.5364 58.9064 67.7708 58.7866L68.1406 59.5106C67.9062 59.6356 67.651 59.7606 67.401 59.8752ZM69.3646 58.8439L68.9479 58.146C69.1771 58.0106 69.4062 57.8647 69.625 57.7241L70.0677 58.4012C69.8333 58.5522 69.5989 58.6981 69.3646 58.8439ZM71.2083 57.6252L70.7187 56.9637C70.9323 56.8022 71.1458 56.6408 71.3542 56.4741L71.8646 57.1095C71.6458 57.2814 71.4271 57.4533 71.2031 57.6252H71.2083ZM72.9167 56.2189L72.375 55.6147C72.5729 55.4377 72.7656 55.2502 72.9583 55.0731L73.526 55.6564C73.3229 55.8335 73.1198 56.0262 72.9167 56.2137V56.2189ZM74.4792 54.6512L73.8698 54.1095C74.0521 53.9064 74.2239 53.7085 74.3958 53.5002L75.0208 54.021C74.8437 54.2293 74.6614 54.4377 74.4739 54.646L74.4792 54.6512ZM75.8698 52.9325L75.2135 52.4481C75.3698 52.2345 75.5208 52.0158 75.6719 51.797L76.3489 52.2502C76.1927 52.4741 76.0312 52.7033 75.8698 52.9272V52.9325ZM77.0781 51.0783L76.375 50.6668C76.5104 50.4377 76.6406 50.2033 76.7656 49.9689L77.4844 50.3543C77.3542 50.5887 77.2135 50.8335 77.0781 51.0731V51.0783ZM78.0937 49.1095L77.3489 48.771C77.4583 48.5314 77.5625 48.2866 77.6667 48.0366L78.4219 48.3439C78.3125 48.5939 78.2031 48.8543 78.0885 49.1043L78.0937 49.1095ZM78.8958 47.047L78.125 46.7866C78.2083 46.5366 78.2864 46.2814 78.3646 46.0262L79.1458 46.2502C79.0625 46.5158 78.9792 46.7814 78.8958 47.0418V47.047ZM79.4896 44.9116L78.6927 44.7345C78.75 44.4793 78.8073 44.2137 78.8542 43.9481L79.6562 44.0991C79.6042 44.3647 79.5469 44.6408 79.4844 44.9064L79.4896 44.9116ZM79.8646 42.7293L79.0469 42.6304C79.0781 42.37 79.1042 42.1043 79.1302 41.8387L79.9427 41.9064C79.9219 42.1772 79.8958 42.4533 79.8594 42.7241L79.8646 42.7293ZM80.0208 40.521L79.2083 40.5054C79.2135 40.2345 79.2135 39.9533 79.2083 39.7033L80.0208 39.6929C80.026 39.9481 80.026 40.2397 80.0156 40.5158L80.0208 40.521Z"
						fill="white"
					/>
				</g>
				<path
					d="M38.1406 65.3958L32.8333 60.0938C32.625 59.8854 32.4635 59.6406 32.3542 59.3698C32.2396 59.099 32.1823 58.8177 32.1823 58.5208C32.1823 58.2292 32.2396 57.9427 32.3542 57.6719C32.4635 57.401 32.625 57.1615 32.8333 56.9531L35.5937 54.1875L44.0625 62.651L41.2812 65.3906C41.0729 65.599 40.8333 65.7604 40.5625 65.875C40.2917 65.9896 40.0052 66.0469 39.7135 66.0469C39.4167 66.0469 39.1354 65.9896 38.8646 65.8802C38.5885 65.7656 38.3489 65.6042 38.1406 65.3958Z"
					fill="white"
				/>
				<path
					d="M44.0625 63.2291L35.0208 54.1875L35.9688 53.2395C38.4479 50.7604 40.0833 47.427 40.5886 43.8437L41.3854 38.1614C41.7708 34.5104 43.4948 30.875 46.1198 28.1927C49.25 24.9843 53.5208 23.2031 58.1354 23.177C67.6042 23.125 74.9063 30.4322 75.0313 39.7552C75.0521 40.7968 74.9792 41.8333 74.8073 42.8593C74.6354 43.8906 74.3698 44.8906 74.0104 45.8697C73.6563 46.8489 73.2083 47.7864 72.6771 48.6875C72.1458 49.5833 71.5365 50.4218 70.849 51.2031C70.1615 51.9895 69.4063 52.7031 68.5833 53.3437C67.7656 53.9843 66.8906 54.5468 65.9688 55.0312C65.0417 55.5104 64.0781 55.901 63.0833 56.2031C62.0833 56.5052 61.0677 56.7135 60.0313 56.8281L54.3698 57.625C52.599 57.875 50.9167 58.3958 49.3125 59.1927C47.7136 59.9895 46.2813 61.0208 45.0156 62.2812L44.0625 63.2291ZM36.1719 54.1875L44.0625 62.0781L44.4375 61.6979C45.7708 60.375 47.2708 59.2968 48.9531 58.4583C50.6302 57.6197 52.3958 57.0729 54.2552 56.8072L59.9323 56.0156C63.1563 55.6562 66.0156 54.4375 68.5 52.3541C72.2604 49.2135 74.2813 44.6458 74.2136 39.7604C74.0938 30.901 67.1875 23.9895 58.2396 23.9895C53.6615 23.9895 49.6042 25.7916 46.6979 28.7656C44.1979 31.3125 42.5573 34.776 42.1875 38.2604L41.3906 43.9531C40.8698 47.7083 39.1458 51.2135 36.5469 53.8072L36.1719 54.1875Z"
					fill="#5E6175"
				/>
				<path
					d="M37.8542 65.6874L32.5469 60.3801C32.2969 60.1353 32.1094 59.8489 31.9739 59.526C31.8385 59.203 31.776 58.8697 31.776 58.5208C31.776 58.1718 31.8385 57.8385 31.9739 57.5155C32.1094 57.1926 32.2969 56.9062 32.5469 56.6614L35.5937 53.6145L44.6406 62.6562L41.5729 65.6874C41.3281 65.9374 41.0417 66.1249 40.7187 66.2603C40.3958 66.3905 40.0625 66.4583 39.7135 66.4583C39.3646 66.4583 39.026 66.3905 38.7031 66.2551C38.3802 66.1249 38.0989 65.9322 37.8542 65.6874ZM35.5937 54.7708L33.125 57.2447C32.9531 57.4166 32.8229 57.6093 32.7292 57.8333C32.6354 58.0572 32.5937 58.2864 32.5937 58.526C32.5937 58.7655 32.6354 58.9999 32.7292 59.2187C32.8229 59.4426 32.9531 59.6405 33.125 59.8072L38.4271 65.1145C38.5989 65.2864 38.7969 65.4166 39.0156 65.5103C39.2396 65.6041 39.4687 65.6458 39.7135 65.6458C39.9531 65.6458 40.1823 65.6041 40.4062 65.5103C40.625 65.4166 40.8229 65.2864 40.9948 65.1145L43.4844 62.651L35.5937 54.7708Z"
					fill="#5E6175"
				/>
				<path
					d="M41.224 59.974L40.6511 59.401L53.375 46.6719L51.7292 45.026L39 57.7604L38.4271 57.1823L51.1563 44.4479L48.8438 42.1406C48.4688 41.7656 48.1823 41.3281 47.9792 40.8385C47.7761 40.349 47.6719 39.8385 47.6719 39.3073C47.6719 38.776 47.7761 38.2656 47.9792 37.776C48.1823 37.2813 48.4688 36.849 48.8438 36.474L49.1771 36.1406C49.5573 35.7656 49.9896 35.474 50.4792 35.2708C50.9688 35.0729 51.4792 34.9688 52.0104 34.9688C52.5417 34.9688 53.0521 35.0729 53.5469 35.2708C54.0365 35.474 54.4688 35.7656 54.8438 36.1406C56.5677 37.8594 56.3854 40.375 54.9011 41.8594L52.3073 44.4479L53.9531 46.0938L56.5261 43.5208C56.9011 43.1458 57.3333 42.8542 57.8229 42.651C58.3177 42.4479 58.8281 42.349 59.3594 42.349C59.8906 42.349 60.4011 42.4479 60.8906 42.651C61.3802 42.8542 61.8125 43.1458 62.1875 43.5208C62.5677 43.8958 62.8542 44.3281 63.0573 44.8229C63.2604 45.3125 63.3646 45.8229 63.3646 46.3542C63.3646 46.8854 63.2604 47.3958 63.0573 47.8854C62.8542 48.375 62.5677 48.8125 62.1875 49.1875L61.875 49.5C61.5 49.875 61.0625 50.1667 60.5729 50.3698C60.0833 50.5729 59.5729 50.6719 59.0417 50.6719C58.5104 50.6719 58 50.5729 57.5104 50.3698C57.0156 50.1667 56.5833 49.875 56.2083 49.5L53.9531 47.2448L41.224 59.974ZM54.5261 46.6719L56.7865 48.9323C57.0833 49.2292 57.4271 49.4583 57.8177 49.6198C58.2136 49.7813 58.6198 49.8646 59.0417 49.8646C59.4636 49.8646 59.8698 49.7813 60.2604 49.6198C60.6511 49.4583 61 49.2292 61.2969 48.9323L61.6146 48.6146C61.9115 48.3125 62.1458 47.9687 62.3073 47.5781C62.4688 47.1875 62.5469 46.7813 62.5469 46.3594C62.5469 45.9323 62.4688 45.526 62.3073 45.1354C62.1458 44.7448 61.9115 44.401 61.6146 44.099C61.3177 43.8021 60.9688 43.5729 60.5781 43.4115C60.1875 43.25 59.7813 43.1667 59.3594 43.1667C58.9375 43.1667 58.5261 43.25 58.1354 43.4115C57.7448 43.5729 57.4011 43.8021 57.1042 44.099L54.5261 46.6719ZM52.0104 35.7812C51.125 35.7812 50.375 36.0885 49.75 36.7135L49.4167 37.0469C49.1198 37.349 48.8906 37.6927 48.7292 38.0833C48.5677 38.474 48.4844 38.8802 48.4844 39.3073C48.4844 39.7292 48.5677 40.1354 48.7292 40.526C48.8906 40.9167 49.1198 41.2604 49.4167 41.5625L51.7292 43.8698L54.3177 41.2812C54.9427 40.6562 55.2552 39.9063 55.2552 39.026C55.25 38.5937 55.1615 38.1823 54.9948 37.7865C54.8281 37.3906 54.5938 37.0417 54.2917 36.7396C53.9896 36.4375 53.6406 36.2031 53.2448 36.0365C52.849 35.8698 52.4375 35.7865 52.0104 35.7812Z"
					fill="#5E6175"
				/>
				<path
					d="M72.5781 68.2499C72.5781 67.7551 72.6719 67.276 72.8594 66.8176C73.0469 66.3645 73.3177 65.9583 73.6667 65.6093C74.0208 65.2603 74.4219 64.9895 74.8802 64.802C75.3385 64.6093 75.8125 64.5155 76.3073 64.5155C75.8125 64.5155 75.3385 64.4218 74.8802 64.2343C74.4219 64.0416 74.0208 63.7708 73.6719 63.4218C73.3177 63.0728 73.0521 62.6718 72.8594 62.2135C72.6719 61.7551 72.5781 61.2812 72.5781 60.7864C72.5781 61.2812 72.4792 61.7551 72.2917 62.2135C72.1042 62.6718 71.8333 63.0728 71.4844 63.4218C71.1354 63.7708 70.7292 64.0416 70.2708 64.2343C69.8125 64.4218 69.3385 64.5155 68.8438 64.5155C69.3385 64.5155 69.8125 64.6093 70.2708 64.802C70.7292 64.9895 71.1354 65.2603 71.4844 65.6093C71.8333 65.9583 72.1042 66.3645 72.2917 66.8228C72.4792 67.276 72.5781 67.7551 72.5781 68.2499Z"
					fill="white"
				/>
				<path
					d="M32.8646 48.672C32.8646 48.3542 32.9271 48.0522 33.0469 47.7553C33.1719 47.4636 33.3438 47.2032 33.5677 46.9792C33.7917 46.7553 34.0521 46.5834 34.3438 46.4636C34.6354 46.3386 34.9427 46.2813 35.2604 46.2813C34.9427 46.2813 34.6354 46.2188 34.3438 46.099C34.0521 45.974 33.7917 45.8022 33.5677 45.5782C33.3438 45.3542 33.1719 45.0938 33.0469 44.8022C32.9271 44.5105 32.8646 44.2032 32.8646 43.8855C32.8646 44.2032 32.8073 44.5105 32.6823 44.8022C32.5625 45.0938 32.3906 45.3542 32.1667 45.5782C31.9427 45.8022 31.6823 45.974 31.3906 46.099C31.0938 46.2188 30.7917 46.2813 30.474 46.2813C30.7917 46.2813 31.0938 46.3386 31.3906 46.4636C31.6823 46.5834 31.9427 46.7553 32.1667 46.9792C32.3906 47.2032 32.5625 47.4636 32.6823 47.7553C32.8073 48.0522 32.8646 48.3542 32.8646 48.672Z"
					fill="white"
				/>
				<path
					d="M23.776 51.5833C23.776 51.3645 23.8177 51.1562 23.901 50.9583C23.9844 50.7551 24.1042 50.578 24.2604 50.427C24.4114 50.2708 24.5885 50.151 24.7917 50.0676C24.9896 49.9843 25.2031 49.9426 25.4167 49.9426C25.2031 49.9426 24.9896 49.901 24.7917 49.8176C24.5885 49.7343 24.4114 49.6197 24.2604 49.4635C24.1042 49.3072 23.9844 49.1301 23.901 48.9322C23.8177 48.7291 23.776 48.5208 23.776 48.302C23.776 48.5208 23.7344 48.7291 23.651 48.9322C23.5677 49.1301 23.4531 49.3072 23.2969 49.4635C23.1458 49.6197 22.9687 49.7343 22.7656 49.8176C22.5625 49.901 22.3542 49.9426 22.1354 49.9426C22.3542 49.9426 22.5625 49.9843 22.7656 50.0676C22.9687 50.151 23.1458 50.2708 23.2969 50.4218C23.4531 50.578 23.5677 50.7551 23.651 50.9583C23.7344 51.1562 23.776 51.3645 23.776 51.5833Z"
					fill="white"
				/>
				<path
					d="M54.0312 29.8436C54.0781 29.4739 54.0729 29.1041 54.0312 28.7291C53.9844 28.3593 53.8958 27.9947 53.7604 27.6457C53.6302 27.2968 53.4583 26.9634 53.2448 26.6561C53.0312 26.3489 52.7864 26.0676 52.5052 25.8228C52.2239 25.5728 51.9167 25.3593 51.5885 25.1822C51.2552 25.0103 50.9062 24.8749 50.5417 24.7864C50.1823 24.6926 49.8125 24.6509 49.4375 24.6457C49.0625 24.6457 48.6927 24.6874 48.3281 24.7759C48.0208 24.2239 47.6406 23.7291 47.1823 23.2916C46.7292 22.8541 46.2135 22.4947 45.6458 22.2134C45.0833 21.9322 44.4844 21.7447 43.8594 21.6457C43.2344 21.552 42.6094 21.5468 41.9844 21.6405C41.3594 21.7395 40.7604 21.9218 40.1927 22.203C39.625 22.4791 39.1094 22.8332 38.651 23.2707C38.1927 23.703 37.8125 24.1978 37.5052 24.7499C37.1927 25.302 36.9792 25.8905 36.8489 26.5103C36.5937 26.453 36.3333 26.427 36.0729 26.4322C35.8073 26.4322 35.5521 26.4634 35.2917 26.5207C35.0364 26.5728 34.7917 26.6614 34.5521 26.7707C34.3125 26.8801 34.0885 27.0155 33.8802 27.1718C33.6719 27.328 33.4844 27.5103 33.3125 27.7082C33.1406 27.9061 32.9948 28.1197 32.8698 28.3541C32.7448 28.5832 32.6458 28.8228 32.5729 29.078C32.5 29.328 32.4531 29.5832 32.4323 29.8436H54.0312Z"
					fill="white"
				/>
				<path
					d="M50.8594 74.2761C50.8281 74.0417 50.8281 73.8126 50.8594 73.5782C50.8854 73.3438 50.9427 73.1199 51.026 72.8959C51.1094 72.6772 51.2187 72.474 51.349 72.2813C51.4844 72.0834 51.6354 71.9115 51.8125 71.7553C51.9896 71.599 52.1823 71.4688 52.3854 71.3542C52.5937 71.2449 52.8125 71.1615 53.0417 71.1095C53.2708 71.0522 53.5 71.0209 53.7344 71.0209C53.9687 71.0209 54.2031 71.047 54.4271 71.099C54.8177 70.3907 55.3802 69.8542 56.1042 69.4949C56.8333 69.1355 57.599 69.0157 58.401 69.1355C59.2031 69.2605 59.901 69.599 60.4896 70.1563C61.0781 70.7136 61.4531 71.3907 61.6146 72.1876C61.9427 72.1199 62.2656 72.1199 62.5885 72.1928C62.9167 72.2657 63.2083 72.4011 63.474 72.6042C63.7396 72.8022 63.9531 73.047 64.1094 73.3438C64.2656 73.6355 64.3594 73.948 64.3802 74.2761H50.8594Z"
					fill="white"
				/>
				<mask
					id="mask4_267_1553"
					maskUnits="userSpaceOnUse"
					x="32"
					y="20"
					width="23"
					height="11">
					<path d="M32 20.8542H54.6667V30.6667H32V20.8542Z" fill="white" />
				</mask>
				<g mask="url(#mask4_267_1553)">
					<path
						d="M54.3958 30.2553H32L32.0312 29.8178C32.0677 29.2657 32.2135 28.7397 32.4688 28.2501C32.7188 27.7553 33.0573 27.3282 33.4844 26.9741C33.9115 26.6199 34.3854 26.3595 34.9167 26.198C35.4479 26.0366 35.9896 25.9897 36.5417 26.047C36.7083 25.4272 36.9635 24.8386 37.3021 24.2918C37.6406 23.7449 38.0521 23.2553 38.5365 22.8282C39.0156 22.4011 39.5521 22.0522 40.1354 21.7813C40.7188 21.5105 41.3281 21.3282 41.9688 21.2345C42.6042 21.1459 43.2448 21.1459 43.8802 21.2397C44.5156 21.3334 45.1302 21.5209 45.7135 21.7918C46.2969 22.0678 46.8281 22.4168 47.3073 22.8491C47.7865 23.2813 48.1927 23.7709 48.5312 24.3178C48.8958 24.2553 49.2604 24.2293 49.6302 24.2449C50 24.2605 50.3646 24.3178 50.7188 24.4116C51.0781 24.5053 51.4167 24.6407 51.7448 24.8126C52.0729 24.9793 52.3802 25.1824 52.6615 25.422C52.9427 25.6616 53.1979 25.922 53.4219 26.2188C53.651 26.5105 53.8385 26.823 53.9948 27.1563C54.151 27.4949 54.2708 27.8386 54.349 28.198C54.4323 28.5626 54.474 28.9272 54.474 29.297C54.4688 29.6147 54.4427 29.9376 54.3958 30.2553ZM32.901 29.4376H53.6562C53.6667 29.1147 53.6406 28.7866 53.5729 28.4688C53.5104 28.1459 53.4115 27.8386 53.276 27.5418C53.1406 27.2449 52.974 26.9688 52.776 26.7084C52.5729 26.448 52.349 26.2188 52.0938 26.0105C51.8438 25.8022 51.5677 25.6303 51.276 25.4845C50.9844 25.3438 50.6771 25.2345 50.3594 25.1616C50.0365 25.0886 49.7188 25.0522 49.3906 25.0574C49.0625 25.0574 48.7396 25.0991 48.4219 25.172L48.1198 25.2449L47.9688 24.9741C47.6875 24.4584 47.3281 23.9949 46.901 23.5834C46.474 23.1772 46 22.8438 45.4688 22.5782C44.9375 22.3178 44.3802 22.1407 43.7969 22.0522C43.2135 21.9584 42.6302 21.9584 42.0469 22.047C41.4635 22.1355 40.9063 22.3074 40.375 22.5678C39.8437 22.8282 39.3646 23.1616 38.9323 23.5678C38.5052 23.9741 38.1458 24.4324 37.8594 24.948C37.5729 25.4636 37.3698 26.0157 37.25 26.5938L37.1667 27.0001L36.7656 26.9063C36.3437 26.8178 35.9167 26.8126 35.4896 26.8959C35.0625 26.9741 34.6719 27.1355 34.3073 27.3699C33.9479 27.6095 33.6406 27.9063 33.401 28.2657C33.1563 28.6251 32.9896 29.0157 32.901 29.4376Z"
						fill="#5E6175"
					/>
				</g>
				<path
					d="M64.8177 74.6824H50.4948L50.4531 74.323C50.4219 74.073 50.4219 73.8178 50.4479 73.5626C50.4792 73.3126 50.5365 73.0678 50.6198 72.823C50.7031 72.5834 50.8177 72.3595 50.9531 72.1459C51.0885 71.9272 51.25 71.7345 51.4323 71.5574C51.6146 71.3803 51.8125 71.224 52.0312 71.0938C52.25 70.9584 52.4792 70.8542 52.724 70.7761C52.9635 70.698 53.2135 70.6459 53.4687 70.6251C53.7187 70.6042 53.974 70.6095 54.224 70.6459C54.6771 69.948 55.2812 69.422 56.0417 69.073C56.8021 68.7292 57.5937 68.6147 58.4219 68.7292C59.2448 68.849 59.9792 69.1772 60.6094 69.7188C61.2448 70.2657 61.6823 70.9324 61.9219 71.7345C62.276 71.7136 62.625 71.7605 62.9635 71.8751C63.2969 71.9949 63.6042 72.1667 63.8698 72.4011C64.1406 72.6407 64.3542 72.9167 64.5104 73.2345C64.6719 73.5522 64.7604 73.8907 64.7865 74.2501L64.8177 74.6824ZM51.2448 73.8699H63.8906C63.7708 73.474 63.5417 73.1563 63.2083 72.9115C62.875 72.6667 62.5052 72.547 62.0885 72.5417C61.8229 72.5574 61.5573 72.599 61.2969 72.6667L61.2187 72.2657C61.0677 71.5574 60.7344 70.9532 60.2031 70.4532C59.6771 69.9532 59.0573 69.6511 58.3385 69.5417C57.6198 69.4324 56.9375 69.5417 56.2865 69.8595C55.6354 70.1824 55.1354 70.6615 54.7865 71.297L54.6354 71.5678C54.3437 71.4845 54.0469 71.4324 53.7448 71.4272C53.4219 71.4272 53.1042 71.4897 52.8021 71.6147C52.5 71.7345 52.2344 71.9115 52 72.1407C51.7656 72.3699 51.5833 72.6303 51.4531 72.9324C51.3229 73.2292 51.25 73.5417 51.2448 73.8699Z"
					fill="#5E6175"
				/>
				<mask
					id="mask5_267_1553"
					maskUnits="userSpaceOnUse"
					x="77"
					y="29"
					width="3"
					height="5">
					<path
						d="M77.3333 29.3333H79.8386V33.3333H77.3333V29.3333Z"
						fill="white"
					/>
				</mask>
				<g mask="url(#mask5_267_1553)">
					<path
						d="M77.4063 31.3436C77.3854 31.1248 77.4167 30.9113 77.5 30.7082C77.5834 30.505 77.7136 30.3331 77.8802 30.1977C78.0521 30.0571 78.2448 29.9686 78.4584 29.9217C78.6771 29.88 78.8907 29.8957 79.099 29.9582C79.3073 30.0259 79.4896 30.1352 79.6459 30.2915C79.8021 30.4477 79.9063 30.63 79.9688 30.8436C80.0313 31.0519 80.0417 31.2654 79.9948 31.4842C79.9479 31.6977 79.8594 31.8904 79.7136 32.0571C79.5469 32.2602 79.3334 32.3957 79.0834 32.4738C78.8282 32.5467 78.5729 32.5467 78.3229 32.4686C78.0729 32.3904 77.8594 32.2498 77.6927 32.0415C77.5261 31.8384 77.4323 31.604 77.4063 31.3436ZM78.7136 30.7238C78.5729 30.7238 78.4532 30.7759 78.3542 30.8748C78.2552 30.9738 78.2136 31.0936 78.2136 31.2342C78.2188 31.3748 78.2761 31.4946 78.3802 31.5884C78.4792 31.6821 78.6042 31.7238 78.7448 31.7186C78.8854 31.7082 79 31.6509 79.0886 31.5415C79.1823 31.4373 79.2188 31.3123 79.2084 31.1717C79.1927 31.0467 79.1407 30.9425 79.0469 30.8592C78.9479 30.7707 78.8386 30.729 78.7136 30.729V30.7238Z"
						fill="#5E6175"
					/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_267_1553">
					<rect width="100" height="100" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

export function TrainingHubIcon() {
	return (
		<svg
			width="100"
			height="100"
			viewBox="0 0 100 100"
			fill="none"
			className="item-icon"
			xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_267_1272)">
				<mask
					id="mask0_267_1272"
					maskUnits="userSpaceOnUse"
					x="0"
					y="0"
					width="100"
					height="100">
					<path d="M0.75 0.75H99.25V99.25H0.75V0.75Z" fill="white" />
				</mask>
				<g mask="url(#mask0_267_1272)">
					<mask
						id="mask1_267_1272"
						maskUnits="userSpaceOnUse"
						x="0"
						y="0"
						width="100"
						height="100">
						<path
							d="M50 0.75C22.8021 0.75 0.75 22.8021 0.75 50C0.75 77.1979 22.8021 99.25 50 99.25C77.1979 99.25 99.25 77.1979 99.25 50C99.25 22.8021 77.1979 0.75 50 0.75Z"
							fill="white"
						/>
					</mask>
					<g mask="url(#mask1_267_1272)">
						<path d="M0.75 0.75H99.25V99.25H0.75V0.75Z" fill="#F6AA3A" />
					</g>
				</g>
				<path
					d="M27.9531 33.1301C27.349 36.276 29.4167 39.328 32.5625 39.9322C32.9063 39.9999 33.2448 40.0312 33.5833 40.0364C33.3177 39.8697 33.0677 39.6822 32.8385 39.4791C32.776 39.4687 32.7135 39.4582 32.6563 39.4478C29.776 38.8957 27.8854 36.1041 28.4427 33.2239C28.9323 30.6822 31.1615 28.9114 33.6563 28.9114C33.9896 28.9114 34.3281 28.9426 34.6667 29.0103C34.7344 29.0207 34.8073 29.0416 34.875 29.0572C35.1667 28.9582 35.4688 28.8749 35.776 28.8176C35.4531 28.6926 35.1146 28.5937 34.7604 28.526C31.6094 27.9166 28.5625 29.9843 27.9531 33.1301Z"
					fill="white"
				/>
				<mask
					id="mask2_267_1272"
					maskUnits="userSpaceOnUse"
					x="22"
					y="49"
					width="17"
					height="39">
					<path
						d="M22.6667 49.3333H38.6667V87.2551H22.6667V49.3333Z"
						fill="white"
					/>
				</mask>
				<g mask="url(#mask2_267_1272)">
					<path
						d="M36.1875 84.0675V60.0727L37.375 53.9061C37.375 53.9061 37.3698 53.9009 37.3646 53.9009H37.3438C36.625 53.7498 36.1458 53.4581 35.75 53.1925C35.3594 52.9269 35.0469 52.6561 34.7656 52.4165L34.6511 52.3175C34.125 51.8696 33.5833 51.4009 32.9636 51.0102C32.6979 50.8436 32.4792 50.63 32.3021 50.3956C32.1927 50.3696 32.0886 50.3383 31.9792 50.3175C30.1458 49.9738 28.8021 50.4269 27.3802 50.9061C27.1458 50.9894 26.9115 51.0675 26.6719 51.1404L26.474 51.1977C25.9323 51.354 25.2656 51.5415 24.2865 51.3852L24.2761 51.38L24.25 51.3748H24.2448L22.9115 58.2863C22.849 58.5311 22.8177 58.7811 22.8177 59.0467V84.0675C22.8177 85.7602 24.1823 87.1248 25.8698 87.1248C27.5625 87.1248 28.9271 85.7602 28.9271 84.0675V61.3956L30.0729 61.6144V84.0675C30.0729 85.7602 31.4427 87.1248 33.1302 87.1248C34.8177 87.1248 36.1875 85.7602 36.1875 84.0675Z"
						fill="white"
					/>
				</g>
				<path
					d="M23.2083 50.328C23.5573 50.5989 23.9792 50.7708 24.3542 50.8437C24.3594 50.8437 24.3646 50.8437 24.375 50.8489C25.3385 51.0051 25.9375 50.7812 26.5104 50.6249C28.1719 50.0937 29.7813 49.3541 32.0833 49.7864C32.4479 49.8541 32.8281 49.9583 33.2344 50.0989C34.2656 50.4635 35.3958 49.9218 35.7604 48.8905C36.1198 47.8593 35.5833 46.7343 34.5521 46.3697C33.9635 46.1614 33.3906 46.0051 32.8333 45.901C30.4688 45.4426 28.4635 45.8541 27.0313 46.2864C26.3542 46.4947 25.7917 46.703 25.401 46.828C25.3958 46.8072 25.3906 46.7864 25.3854 46.7708C25.349 46.6405 25.3281 46.4843 25.3229 46.3072L25.8698 46.0937C26.1615 45.9947 26.5 45.8801 26.875 45.7655C28.9948 45.1197 30.9688 44.9895 32.9167 45.3645C33.5313 45.4791 34.1406 45.6458 34.7344 45.8541C35.3542 46.0728 35.8281 46.5155 36.1146 47.052C36.6875 47.4478 37.1771 47.8437 37.6198 48.2187C37.6927 48.2812 37.7604 48.3385 37.8281 48.3958L38.2552 48.7968C38.1875 48.9583 38.1094 49.0989 38.026 49.203C38.0156 49.2187 38 49.2343 37.9896 49.2499C37.7969 49.0937 37.5521 48.8801 37.2708 48.6353C37.0104 48.4166 36.7188 48.177 36.3958 47.927C36.4427 48.302 36.4063 48.6926 36.2708 49.0728C35.8698 50.2135 34.6927 50.9062 33.5104 50.7239C34.0938 51.1249 34.6094 51.5676 35.1198 51.9999C35.4115 52.2499 35.7031 52.4999 36.0521 52.7395C36.401 52.9791 36.8229 53.2343 37.4531 53.3645C37.4583 53.3645 37.4635 53.3697 37.4688 53.3697C37.8438 53.4426 38.3021 53.4374 38.7292 53.3124C39.7813 53.0155 40.6042 52.3541 41.1771 51.5937C41.7552 50.828 42.1198 49.9478 42.3021 49.0208C42.5625 47.6562 42.4271 46.1458 41.6667 44.776C40.9635 43.4895 39.625 42.4322 37.9375 42.0312C37.8698 42.0103 37.7969 41.9947 37.724 41.9791L37.7135 41.9739L28.349 40.1718C28.276 40.1562 28.2031 40.151 28.1302 40.1458C26.4167 39.8905 24.7813 40.3749 23.651 41.3072C22.4375 42.2968 21.75 43.6458 21.4844 45.0103C21.3125 45.9218 21.3177 46.8541 21.5573 47.7655C21.5625 47.7812 21.5677 47.802 21.5729 47.8176C21.8229 48.7395 22.3438 49.6614 23.2083 50.328Z"
					fill="white"
				/>
				<path
					d="M31.3958 33.802C30.8125 36.8229 32.7917 39.7395 35.8073 40.3177C38.8229 40.901 41.7396 38.9218 42.3229 35.9062C42.901 32.8906 40.9271 29.9739 37.9115 29.3906C34.8958 28.8124 31.9792 30.7864 31.3958 33.802ZM34.75 36.3385C36.9271 37.6354 40.3333 36.8906 40.3333 36.8906C37.0781 40.8489 34.75 36.3385 34.75 36.3385Z"
					fill="white"
				/>
				<path
					d="M32.0104 26.3489L34.7344 27.0885L34.2708 26.3072C37.8958 26.1145 43.4792 27.0208 44.375 34.1874L43.5156 33.8749L44.7448 36.4166L45.7135 33.7603L44.8698 34.1718C43.9063 26.3072 37.4323 25.6458 34.1927 25.8176L34.4427 24.9114L32.0104 26.3489Z"
					fill="white"
				/>
				<path
					d="M57.0729 40.8386C56.276 40.4115 55.2865 40.5834 54.6771 41.2552L53.8594 42.1511C53.125 42.9584 53.1823 44.2084 53.9896 44.9427C54.7135 45.6042 55.7917 45.625 56.5365 45.0417L59.7448 46.7656C60.2917 45.4219 60.9427 44.2188 61.724 43.3334L57.0729 40.8386Z"
					fill="white"
				/>
				<path
					d="M69.3125 31.4844C69.5573 31.7552 69.776 32.0469 69.9688 32.3594C70.1563 32.6719 70.3125 33 70.4427 33.3386C70.5677 33.6823 70.6563 34.0365 70.7135 34.3958C70.7656 34.7552 70.7865 35.1198 70.7708 35.4844C70.7552 35.849 70.7083 36.2083 70.6198 36.5677C70.5313 36.9219 70.4115 37.2656 70.2604 37.5938C70.1042 37.9271 69.9219 38.2396 69.7031 38.5313C69.4896 38.8281 69.2448 39.099 68.9792 39.3438C68.7083 39.5938 68.4167 39.8125 68.1042 40C67.7917 40.1927 67.4635 40.349 67.125 40.474C66.7813 40.599 66.4271 40.6875 66.0677 40.7448C65.7031 40.8021 65.3438 40.8229 64.9792 40.8073C64.6146 40.7917 64.2552 40.7396 63.8958 40.6511C63.5417 40.5677 63.1979 40.4479 62.8698 40.2917C62.5365 40.1406 62.224 39.9531 61.9323 39.7396C61.6354 39.5208 61.3646 39.2813 61.1146 39.0104C60.8698 38.7396 60.651 38.4531 60.4635 38.1406C60.2708 37.8281 60.1146 37.5 59.9896 37.1563C59.8646 36.8125 59.7708 36.4636 59.7188 36.099C59.6615 35.7396 59.6406 35.375 59.6563 35.0104C59.6719 34.6458 59.724 34.2865 59.8125 33.9323C59.8958 33.5781 60.0156 33.2344 60.1719 32.9011C60.3229 32.5729 60.5104 32.2604 60.724 31.9636C60.9427 31.6667 61.1823 31.3958 61.4531 31.1511C61.724 30.9063 62.0104 30.6875 62.3229 30.4948C62.6354 30.3073 62.9635 30.1458 63.3073 30.0208C63.651 29.8958 64 29.8073 64.3646 29.75C64.724 29.6927 65.0885 29.6771 65.4531 29.6927C65.8177 29.7083 66.1771 29.7552 66.5313 29.8438C66.8854 29.9323 67.2292 30.0521 67.5625 30.2031C67.8906 30.3594 68.2031 30.5417 68.5 30.7604C68.7969 30.974 69.0677 31.2188 69.3125 31.4844Z"
					fill="white"
				/>
				<path
					d="M44.4479 55.2917L44.5677 55.1407L43.9844 54.4063L49.7031 47.1303C50.0625 47.0782 51.5781 46.9792 54.4115 48.5001L54.8073 48.7136L54.849 48.2657C54.8698 48.0365 55.375 47.5209 55.875 47.1459C56.0729 47.2188 56.4375 47.3595 56.7604 47.5365L55.349 49.4324L50.5365 48.3386L44.7969 55.8178L51.3125 56.9428L52.2969 55.5417L50.3177 54.5261C49.0677 53.8803 48.5781 52.3438 49.2187 51.0938C49.6562 50.2397 50.526 49.7136 51.4844 49.7136C51.8854 49.7136 52.2917 49.8126 52.651 49.9949L55.2656 51.3438L58.1771 47.2188L57.5885 46.9949L57.3698 46.9115L57.2187 47.1095C56.6667 46.7865 55.9583 46.5417 55.9271 46.5313L55.7812 46.4792L55.6562 46.5678C55.474 46.698 54.7135 47.2605 54.3958 47.8178C51.0833 46.1147 49.5208 46.5574 49.4531 46.573L49.3646 46.6042L43.224 54.4063L44.1667 55.5938L44.4479 55.2917Z"
					fill="white"
				/>
				<mask
					id="mask3_267_1272"
					maskUnits="userSpaceOnUse"
					x="49"
					y="40"
					width="30"
					height="48">
					<path d="M49.3333 40H78.3177V87.2552H49.3333V40Z" fill="white" />
				</mask>
				<g mask="url(#mask3_267_1272)">
					<path
						d="M78.5833 58.8334L75.2292 42.2605C75.0156 41.2292 74.0104 40.5573 72.974 40.7657L65.2448 42.3334L63.6146 42.6615C63.151 42.7553 62.7656 43.0105 62.4948 43.3542C60.2813 45.4584 59.0521 50.3803 58.4583 53.6251L52.3906 50.5001C51.4167 50.0001 50.224 50.3855 49.724 51.3542C49.224 52.323 49.6042 53.5157 50.5781 54.0157L59.0833 58.4011C59.3698 58.5469 59.6771 58.6198 59.9896 58.6198C60.3073 58.6198 60.625 58.5417 60.9167 58.3907C61.4844 58.0886 61.875 57.5261 61.9531 56.8855C62.2083 54.7865 62.6823 52.4636 63.25 50.5001L63.5 51.7448L65.2917 60.5834V84.6719C65.2917 86.3646 66.6615 87.7292 68.349 87.7292C70.0365 87.7292 71.4062 86.3646 71.4062 84.6719V62.2344L72.5521 62.0053V84.6719C72.5521 86.3646 73.9219 87.7292 75.6094 87.7292C77.2969 87.7292 78.6667 86.3646 78.6667 84.6719V59.6459C78.6667 59.4636 78.6458 59.2865 78.6146 59.1094C78.6094 59.0209 78.6042 58.9271 78.5833 58.8334Z"
						fill="white"
					/>
				</g>
				<mask
					id="mask4_267_1272"
					maskUnits="userSpaceOnUse"
					x="42"
					y="12"
					width="22"
					height="18">
					<path d="M42.6667 12.2551H64V29.3333H42.6667V12.2551Z" fill="white" />
				</mask>
				<g mask="url(#mask4_267_1272)">
					<path
						d="M62.0052 12.2708H44.8021C43.8698 12.2708 43.1146 13.026 43.1146 13.9583V22.1301C43.1146 23.0624 43.8698 23.8176 44.8021 23.8176H54.5208L61.6094 29.0989L57.4583 23.8176H62.0052C62.9375 23.8176 63.6927 23.0624 63.6927 22.1301V13.9583C63.6927 13.026 62.9375 12.2708 62.0052 12.2708ZM48.6667 19.1874C48.0365 19.1874 47.5208 18.677 47.5208 18.0468C47.5208 17.4166 48.0365 16.901 48.6667 16.901C49.2969 16.901 49.8073 17.4166 49.8073 18.0468C49.8073 18.677 49.2969 19.1874 48.6667 19.1874ZM52.2604 18.0468C52.2604 17.4166 52.7708 16.901 53.4011 16.901C54.0365 16.901 54.5469 17.4166 54.5469 18.0468C54.5469 18.677 54.0365 19.1874 53.4011 19.1874C52.7708 19.1874 52.2604 18.677 52.2604 18.0468ZM58.1406 19.1874C57.5052 19.1874 56.9948 18.677 56.9948 18.0468C56.9948 17.4166 57.5052 16.901 58.1406 16.901C58.7708 16.901 59.2813 17.4166 59.2813 18.0468C59.2813 18.677 58.7708 19.1874 58.1406 19.1874Z"
						fill="white"
					/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_267_1272">
					<rect width="100" height="100" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

export function SetYourCalendarIcon() {
	return (
		<svg
			width="100"
			height="100"
			viewBox="0 0 100 100"
			fill="none"
			className="item-icon"
			xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_267_1453)">
				<mask
					id="mask0_267_1453"
					maskUnits="userSpaceOnUse"
					x="0"
					y="0"
					width="100"
					height="100">
					<path d="M0.75 0.75H99.25V99.25H0.75V0.75Z" fill="white" />
				</mask>
				<g mask="url(#mask0_267_1453)">
					<mask
						id="mask1_267_1453"
						maskUnits="userSpaceOnUse"
						x="0"
						y="0"
						width="100"
						height="100">
						<path
							d="M50 0.75C22.8021 0.75 0.75 22.8021 0.75 50C0.75 77.1979 22.8021 99.25 50 99.25C77.1979 99.25 99.25 77.1979 99.25 50C99.25 22.8021 77.1979 0.75 50 0.75Z"
							fill="white"
						/>
					</mask>
					<g mask="url(#mask1_267_1453)">
						<path d="M0.75 0.75H99.25V99.25H0.75V0.75Z" fill="#F6AA3A" />
					</g>
				</g>
				<mask
					id="mask2_267_1453"
					maskUnits="userSpaceOnUse"
					x="26"
					y="24"
					width="54"
					height="56">
					<path d="M26.6667 24H80V79.8698H26.6667V24Z" fill="white" />
				</mask>
				<g mask="url(#mask2_267_1453)">
					<path
						d="M59.2292 79.901C56.8177 79.901 54.6354 79.2552 52.5729 77.9219C50.2552 76.4323 48.1719 74.5677 46.1614 72.7656C45.8021 72.4479 45.4479 72.1302 45.0937 71.8125C44.0781 70.9167 43.0469 70.0104 42.0469 69.1302C38.5104 66.0208 34.8542 62.8073 31.4167 59.4688C30.6614 58.7344 30.1458 58.0938 29.7396 57.3854C28.5156 55.2396 28.5573 54.3906 29.9531 53.0625C30.3229 52.7135 30.9844 52.5156 31.7708 52.5156C32.6719 52.5156 33.5729 52.7708 34.25 53.2188C35.375 53.9635 37.5312 55.9219 39.6198 57.8177C41.2552 59.3021 42.8021 60.7031 43.8958 61.5729C43.9948 61.651 44.1094 61.6927 44.2239 61.6927C44.4271 61.6927 44.6146 61.5729 44.7083 61.3854C44.7969 61.2031 44.7708 60.9948 44.6458 60.8333C42.9948 58.7188 38.9219 54.5313 37 52.6094C36.1094 51.724 35.2031 50.8281 34.3229 49.9583C32.7292 48.3802 31.0781 46.7552 29.4896 45.125C28.2708 43.8802 27.026 42.3958 27.651 40.5C28.1146 39.0833 29.1458 38.3021 30.5625 38.3021C31.6146 38.3021 32.7656 38.7604 33.7239 39.5521C35.5208 41.0417 37.1562 42.8021 38.7396 44.5052C39.3281 45.1406 39.9375 45.7917 40.5469 46.4219C40.9167 46.8073 41.3958 47.3229 41.9479 47.9167C43.7344 49.8281 46.1771 52.4427 47.6354 53.599C47.7396 53.6823 47.8646 53.724 47.9948 53.724C48.2031 53.724 48.4062 53.6042 48.5104 53.4167C48.6146 53.2292 48.6042 53.0052 48.4896 52.8229C47.9271 51.9427 47.125 51.0729 46.4219 50.3125C46.0312 49.8906 45.6614 49.4896 45.3698 49.1302C44.1354 47.5938 42.8021 46.099 41.5156 44.651C40.375 43.3646 39.1927 42.0365 38.0833 40.6875C37.6042 40.1042 36.9167 39.3698 36.125 38.5104C34.2396 36.4844 31.8958 33.9635 31.2135 32.2969C30.625 30.8646 31.0417 29.3802 32.276 28.5104C32.901 28.0677 33.5625 27.849 34.2552 27.849C35.0156 27.849 35.7864 28.1146 36.5417 28.6406C37.75 29.4792 38.6823 30.6198 39.5885 31.724C39.8854 32.0833 40.1875 32.4583 40.5 32.8125C43.7135 36.5104 50.1354 43.776 52.5833 46.5C52.6771 46.6042 52.7969 46.6562 52.9271 46.6562C53.0989 46.6562 53.2604 46.5625 53.3437 46.4115C53.4219 46.2708 53.4167 46.0938 53.3281 45.9479C52.1614 44.0417 49.3542 40.1458 45.2135 34.6875C45.0312 34.4479 44.8437 34.1979 44.6458 33.9427C43.4583 32.3906 42.1146 30.6302 41.3958 29.276C41.0312 28.5521 41.0312 27.7656 41.401 26.9531C41.8646 25.9167 42.8385 25.151 43.9323 24.9531C44.1146 24.9219 44.2969 24.9062 44.4739 24.9062C45.125 24.9062 45.7604 25.1198 46.3698 25.5417C47.3021 26.1875 48.8802 28.1979 50.5469 30.3281C51.6667 31.7604 52.8281 33.2448 53.9062 34.4531C54.5156 35.1458 55.9219 36.9792 57.4114 38.9219C59.3489 41.4427 61.5417 44.2969 62.5104 45.3281C63.3021 46.1615 64.1667 46.5833 65.0885 46.5833C65.4635 46.5833 65.8542 46.5104 66.2448 46.3698C67.5885 45.8854 68.3177 44.7865 68.3021 43.2656C68.2656 40.2396 69.1094 37.8125 70.8854 35.8542C71.8542 34.7865 74.25 33.9167 76.2187 33.9167C76.9635 33.9167 77.5833 34.0417 78.0156 34.2812C79.4375 35.0625 79.8594 36.4948 79.125 38.0156C78.9062 38.4635 78.6771 38.9219 78.4583 39.3594C77.3489 41.5625 76.2031 43.8385 75.9687 46.4896C75.8333 47.9688 76.0364 49.401 76.2292 50.7812C76.3021 51.2812 76.375 51.8021 76.4271 52.3177C76.5521 53.4479 76.7344 54.5938 76.9114 55.7083C77.3333 58.3646 77.7708 61.1146 77.3958 63.8281V63.8438C77.1823 68.3594 74.5833 71.8125 72.4427 73.9167C69.9271 76.3958 66.6042 78.3906 63.5573 79.2604C62.0469 79.6875 60.5937 79.901 59.2292 79.901Z"
						fill="white"
					/>
				</g>
				<mask
					id="mask3_267_1453"
					maskUnits="userSpaceOnUse"
					x="27"
					y="24"
					width="53"
					height="56">
					<path
						d="M27.1667 24.6511H79.6979V79.8699H27.1667V24.6511Z"
						fill="white"
					/>
				</mask>
				<g mask="url(#mask3_267_1453)">
					<path
						d="M44.474 24.6875C44.2865 24.6875 44.0885 24.7031 43.8958 24.7396C42.7135 24.9531 41.6979 25.7656 41.2031 26.8646C40.875 27.5833 40.7448 28.4687 41.2083 29.375C42.0521 30.974 43.7396 33.1042 45.0417 34.8229C47.1198 37.5625 51.5 43.3802 53.1458 46.0625C53.2604 46.25 53.099 46.4427 52.9271 46.4427C52.8646 46.4427 52.8021 46.4167 52.7448 46.3542C50.3021 43.6354 43.849 36.3333 40.6615 32.6719C39.3958 31.2135 38.2917 29.5938 36.6667 28.4635C35.875 27.9115 35.0573 27.6302 34.2552 27.6302C33.5312 27.6302 32.8177 27.8594 32.151 28.3333C30.9271 29.1927 30.3385 30.7344 31.0104 32.375C32 34.7813 36.2865 38.849 37.9115 40.8229C40.2812 43.7031 42.8698 46.3698 45.2031 49.2656C46.0208 50.2813 47.4479 51.5938 48.3021 52.9375C48.4792 53.2083 48.2552 53.5104 47.9948 53.5104C47.9219 53.5104 47.8437 53.4844 47.7708 53.4271C45.875 51.9271 42.2708 47.901 40.7031 46.276C38.4531 43.9427 36.3385 41.4375 33.8594 39.3854C32.8594 38.5573 31.6667 38.0885 30.5625 38.0885C29.1979 38.0885 27.9792 38.8021 27.4427 40.4323C26.7865 42.4323 28.0625 43.974 29.3333 45.276C31.8021 47.8021 34.349 50.2708 36.8437 52.7656C38.7812 54.6979 42.8281 58.8594 44.474 60.9635C44.651 61.1927 44.4583 61.4792 44.224 61.4792C44.1615 61.4792 44.0937 61.4583 44.0312 61.4062C41.5052 59.3958 36.3698 54.3646 34.3698 53.0365C33.6198 52.5417 32.6562 52.2969 31.7708 52.2969C30.9635 52.2969 30.2292 52.5 29.8073 52.9062C28.3021 54.3333 28.2917 55.2865 29.5521 57.4948C30.0208 58.3125 30.6094 58.9896 31.2656 59.625C35.6771 63.9115 40.349 67.901 44.9479 71.9792C47.3646 74.1198 49.724 76.3438 52.4531 78.1042C54.625 79.5052 56.8906 80.1198 59.2292 80.1198C60.6667 80.1198 62.1302 79.8906 63.6198 79.4688C69.2865 77.8542 77.2292 71.901 77.6146 63.8542C78.1458 59.9792 77.0625 56.1458 76.6458 52.2917C76.4375 50.3802 76.0052 48.5052 76.1823 46.5104C76.4635 43.375 78.0156 40.8073 79.3177 38.1094C80.099 36.4948 79.6458 34.9323 78.1198 34.0885C77.6302 33.8177 76.9583 33.6979 76.2187 33.6979C74.2552 33.6979 71.7812 34.5469 70.724 35.7083C68.7552 37.8802 68.0469 40.4271 68.0833 43.2708C68.099 44.651 67.4583 45.7031 66.1719 46.1667C65.7969 46.3021 65.4375 46.3646 65.0885 46.3646C64.1979 46.3646 63.3906 45.9375 62.6719 45.1771C60.9583 43.3698 55.4844 35.9063 54.0677 34.3073C51.375 31.2813 48.0885 26.4635 46.4948 25.3646C45.8854 24.9427 45.2031 24.6875 44.474 24.6875ZM44.474 25.125C45.0781 25.125 45.6771 25.3229 46.25 25.7188C47.151 26.3438 48.7187 28.3437 50.375 30.4635C51.5 31.8958 52.6615 33.3802 53.7396 34.599C54.349 35.2813 55.7552 37.1146 57.2396 39.0521C59.1771 41.5781 61.375 44.4375 62.3542 45.474C63.1875 46.3542 64.1094 46.8021 65.0885 46.8021C65.4896 46.8021 65.901 46.724 66.3177 46.5781C67.7344 46.0677 68.5365 44.8594 68.5156 43.2656C68.5 41.8125 68.6771 40.5365 69.0625 39.375C69.4844 38.1146 70.1302 37.0104 71.0469 36C71.9792 34.974 74.3021 34.1354 76.2187 34.1354C76.9271 34.1354 77.5104 34.25 77.9115 34.4688C78.5573 34.8229 78.9896 35.3281 79.1667 35.9323C79.349 36.5365 79.2656 37.224 78.9271 37.9219C78.7135 38.3698 78.4844 38.8229 78.2604 39.2604C77.1458 41.4792 75.9896 43.776 75.75 46.4688C75.6146 47.974 75.8177 49.4167 76.0156 50.8073C76.0833 51.3125 76.1562 51.8281 76.2135 52.3385C76.3333 53.4792 76.5208 54.6302 76.6979 55.7396C77.1146 58.3854 77.5521 61.1198 77.1823 63.7969V63.8177L77.1771 63.8333C76.9687 68.2813 74.4062 71.6875 72.2917 73.7656C69.7969 76.2188 66.5104 78.1927 63.5 79.0521C62.0104 79.474 60.5729 79.6875 59.2292 79.6875C56.8594 79.6875 54.7187 79.0521 52.6875 77.7396C50.3906 76.2552 48.3125 74.401 46.3021 72.6042C45.9531 72.2917 45.5937 71.9688 45.2344 71.651C44.224 70.7552 43.1875 69.8438 42.1875 68.9688C38.6562 65.8594 35 62.6458 31.5677 59.3125C30.8281 58.5938 30.3229 57.9688 29.9271 57.276C29.3021 56.1823 29.0469 55.4792 29.0781 54.9271C29.099 54.3854 29.401 53.8906 30.1042 53.2188C30.4271 52.9115 31.0521 52.7292 31.7708 52.7292C32.6302 52.7292 33.4896 52.974 34.1302 53.401C35.2396 54.1354 37.3906 56.0885 39.474 57.974C41.1094 59.4635 42.6615 60.8698 43.7604 61.7448C43.8958 61.8542 44.0573 61.9115 44.224 61.9115C44.5104 61.9115 44.776 61.7448 44.901 61.4844C45.026 61.2292 44.9948 60.9271 44.8177 60.6979C43.1562 58.5781 39.0781 54.3802 37.151 52.4583C36.2656 51.5677 35.3542 50.6719 34.474 49.8021C32.8802 48.2292 31.2344 46.599 29.6458 44.974C28.4167 43.7188 27.2708 42.349 27.8542 40.5677C28.2865 39.25 29.25 38.5208 30.5625 38.5208C31.5625 38.5208 32.6667 38.9583 33.5833 39.7188C35.3698 41.1979 37.0052 42.9531 38.5833 44.651C39.1719 45.2865 39.7812 45.9427 40.3906 46.5729C40.7604 46.9583 41.2396 47.4688 41.7917 48.0677C43.5781 49.9792 46.0312 52.6042 47.5 53.7656C47.6458 53.8802 47.8177 53.9427 47.9948 53.9427C48.2865 53.9427 48.5573 53.7813 48.6979 53.5208C48.8437 53.2604 48.8281 52.9583 48.6719 52.7083C48.099 51.8073 47.2917 50.9375 46.5833 50.1667C46.1927 49.7448 45.8229 49.349 45.5417 48.9948C44.3021 47.4531 42.9687 45.9531 41.6771 44.5052C40.5365 43.224 39.3594 41.8958 38.25 40.5521C37.7656 39.9635 37.0781 39.224 36.2812 38.3646C34.4115 36.349 32.0833 33.8438 31.4115 32.2135C31.1302 31.526 31.0885 30.8281 31.2865 30.1927C31.4687 29.5885 31.8542 29.0677 32.401 28.6875C32.9896 28.2708 33.6094 28.0625 34.2552 28.0625C34.9687 28.0625 35.6979 28.3177 36.4219 28.8177C37.599 29.6406 38.4844 30.7188 39.4219 31.8594C39.7187 32.224 40.0208 32.5937 40.3385 32.9583C43.5521 36.6563 49.974 43.9219 52.4219 46.6458C52.5573 46.7917 52.7344 46.875 52.9271 46.875C53.1771 46.875 53.4115 46.7396 53.5312 46.5208C53.651 46.3073 53.6458 46.0469 53.5156 45.8333C52.3385 43.9219 49.5312 40.0208 45.3854 34.5573C45.2031 34.3177 45.0156 34.0677 44.8177 33.8125C43.6406 32.2708 42.3021 30.5156 41.5937 29.1771C41.2552 28.5104 41.2604 27.7917 41.599 27.0417C42.0365 26.0729 42.9427 25.3542 43.974 25.1667C44.1406 25.1354 44.3073 25.125 44.474 25.125Z"
						fill="white"
					/>
				</g>
				<path
					d="M52.7812 21.5365C56.4062 23.5782 59.3437 26.7188 61.1823 30.448C61.6875 31.4792 62.099 32.5469 62.4219 33.6563C62.6771 34.5313 64.0469 34.1615 63.7917 33.2813C62.5521 29.0573 60.0104 25.2188 56.599 22.4375C55.625 21.6459 54.5937 20.9323 53.4948 20.3125C52.7031 19.8646 51.9844 21.0886 52.7812 21.5365Z"
					fill="white"
				/>
				<path
					d="M51.3281 25.7188C54.5417 27.6043 56.9115 30.7501 57.9323 34.3282C58.1823 35.2032 59.5469 34.8282 59.2969 33.948C58.4271 30.9063 56.6615 28.1095 54.2448 26.0626C53.5573 25.4793 52.8229 24.948 52.0469 24.4949C51.2552 24.0313 50.5417 25.2553 51.3281 25.7188Z"
					fill="white"
				/>
				<mask
					id="mask4_267_1453"
					maskUnits="userSpaceOnUse"
					x="20"
					y="58"
					width="15"
					height="14">
					<path
						d="M20.0938 58.6665H34.6667V71.9998H20.0938V58.6665Z"
						fill="white"
					/>
				</mask>
				<g mask="url(#mask4_267_1453)">
					<path
						d="M20.3021 59.8021C22.2031 63.7605 25.3594 67.1042 29.1614 69.2917C30.2552 69.9219 31.4114 70.448 32.5989 70.8803C32.9583 71.0157 33.375 70.7344 33.4687 70.3855C33.5781 69.9949 33.3385 69.6459 32.9739 69.5157C29.1354 68.1146 25.7083 65.4896 23.3333 62.1511C22.6458 61.1824 22.0417 60.1563 21.526 59.0834C21.3594 58.7396 20.8698 58.6511 20.5573 58.8282C20.2031 59.0365 20.1354 59.4532 20.3021 59.8021Z"
						fill="white"
					/>
				</g>
				<path
					d="M24.5677 58.6196C25.9792 61.4269 28.2865 63.7706 31.0208 65.3019C31.8333 65.7498 32.6823 66.13 33.5573 66.4425C33.9167 66.5727 34.3333 66.2966 34.4271 65.9477C34.5365 65.5571 34.2969 65.2029 33.9323 65.0779C30.4323 63.8279 27.4635 61.2237 25.7917 57.906C25.6198 57.5623 25.1354 57.4685 24.8229 57.6508C24.474 57.8539 24.3958 58.2758 24.5677 58.6196Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_267_1453">
					<rect width="100" height="100" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

export function PersonalSchedulerIcon() {
	return (
		<svg
			width="100"
			height="100"
			viewBox="0 0 100 100"
			fill="none"
			className="item-icon"
			xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_267_1484)">
				<mask
					id="mask0_267_1484"
					maskUnits="userSpaceOnUse"
					x="0"
					y="0"
					width="100"
					height="100">
					<path d="M0.75 0.75H99.25V99.25H0.75V0.75Z" fill="white" />
				</mask>
				<g mask="url(#mask0_267_1484)">
					<mask
						id="mask1_267_1484"
						maskUnits="userSpaceOnUse"
						x="0"
						y="0"
						width="100"
						height="100">
						<path
							d="M50 0.75C22.8021 0.75 0.75 22.8021 0.75 50C0.75 77.1979 22.8021 99.25 50 99.25C77.1979 99.25 99.25 77.1979 99.25 50C99.25 22.8021 77.1979 0.75 50 0.75Z"
							fill="white"
						/>
					</mask>
					<g mask="url(#mask1_267_1484)">
						<path d="M0.75 0.75H99.25V99.25H0.75V0.75Z" fill="#F6AA3A" />
					</g>
				</g>
				<path
					d="M37.6562 28.6929H61.974C62.1979 28.6929 62.3802 28.5106 62.3802 28.2866V27.0679C62.3802 26.8439 62.1979 26.6616 61.974 26.6616H37.6562C37.4323 26.6616 37.25 26.8439 37.25 27.0679V28.2866C37.25 28.5106 37.4323 28.6929 37.6562 28.6929Z"
					fill="white"
				/>
				<mask
					id="mask2_267_1484"
					maskUnits="userSpaceOnUse"
					x="20"
					y="26"
					width="60"
					height="52">
					<path
						d="M20.2188 26.6562H79.7656V77.7865H20.2188V26.6562Z"
						fill="white"
					/>
				</mask>
				<g mask="url(#mask2_267_1484)">
					<path
						d="M73.4375 75.7502H26.5521C24.1771 75.7502 22.2552 73.8283 22.2552 71.4533V42.8387H77.7344V71.4533C77.7344 73.8283 75.8125 75.7502 73.4375 75.7502ZM73.4375 26.6616H68.8906C68.6667 26.6616 68.4844 26.8439 68.4844 27.0679V28.2866C68.4844 28.5106 68.6667 28.6929 68.8906 28.6929H73.4375C75.8073 28.6929 77.7344 30.62 77.7344 32.995V40.8022H22.2552V32.995C22.2552 30.62 24.1823 28.6929 26.5521 28.6929H30.7396C30.9635 28.6929 31.1458 28.5106 31.1458 28.2866V27.0679C31.1458 26.8439 30.9635 26.6616 30.7396 26.6616H26.5521C23.0625 26.6616 20.2188 29.5054 20.2188 32.995V71.4533C20.2188 74.9377 23.0677 77.7866 26.5521 77.7866H73.4375C76.9167 77.7866 79.7656 74.9377 79.7656 71.4533V32.995C79.7656 29.5054 76.9271 26.6616 73.4375 26.6616Z"
						fill="white"
					/>
				</g>
				<path
					d="M34.1979 33.6407C35.2083 33.6407 36.026 32.8282 36.026 31.8126V24.547C36.026 23.5313 35.2083 22.7136 34.1979 22.7136C33.1875 22.7136 32.3698 23.5313 32.3698 24.547V31.8126C32.3698 32.8282 33.1875 33.6407 34.1979 33.6407Z"
					fill="white"
				/>
				<mask
					id="mask3_267_1484"
					maskUnits="userSpaceOnUse"
					x="62"
					y="22"
					width="6"
					height="12">
					<path d="M62.6667 22.2083H68V33.3333H62.6667V22.2083Z" fill="white" />
				</mask>
				<g mask="url(#mask3_267_1484)">
					<path
						d="M65.4323 33.1405C66.4427 33.1405 67.2604 32.3228 67.2604 31.3123V24.0415C67.2604 23.0311 66.4427 22.2134 65.4323 22.2134C64.4219 22.2134 63.6042 23.0311 63.6042 24.0415V31.3123C63.6042 32.3228 64.4219 33.1405 65.4323 33.1405Z"
						fill="white"
					/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_267_1484">
					<rect width="100" height="100" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

export function AutomatePaymentsIcon() {
	return (
		<svg
			width="100"
			height="100"
			viewBox="0 0 100 100"
			fill="none"
			className="item-icon"
			xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_267_1511)">
				<mask
					id="mask0_267_1511"
					maskUnits="userSpaceOnUse"
					x="0"
					y="0"
					width="100"
					height="100">
					<path d="M0.75 0.75H99.25V99.25H0.75V0.75Z" fill="white" />
				</mask>
				<g mask="url(#mask0_267_1511)">
					<mask
						id="mask1_267_1511"
						maskUnits="userSpaceOnUse"
						x="0"
						y="0"
						width="100"
						height="100">
						<path
							d="M50 0.75C22.8021 0.75 0.75 22.8021 0.75 50C0.75 77.1979 22.8021 99.25 50 99.25C77.1979 99.25 99.25 77.1979 99.25 50C99.25 22.8021 77.1979 0.75 50 0.75Z"
							fill="white"
						/>
					</mask>
					<g mask="url(#mask1_267_1511)">
						<path d="M0.75 0.75H99.25V99.25H0.75V0.75Z" fill="#F6AA3A" />
					</g>
				</g>
				<mask
					id="mask2_267_1511"
					maskUnits="userSpaceOnUse"
					x="19"
					y="24"
					width="57"
					height="10">
					<path d="M19.9323 24.8179H76V33.3335H19.9323V24.8179Z" fill="white" />
				</mask>
				<g mask="url(#mask2_267_1511)">
					<path
						d="M75.0469 32.4219V29.9167C75.0469 27.1615 72.7917 24.9062 70.0364 24.9062H24.9427C22.1875 24.9062 19.9323 27.1615 19.9323 29.9167V32.4219H75.0469Z"
						fill="white"
					/>
				</g>
				<mask
					id="mask3_267_1511"
					maskUnits="userSpaceOnUse"
					x="19"
					y="38"
					width="57"
					height="28">
					<path d="M19.9323 38.6665H76V65.3332H19.9323V38.6665Z" fill="white" />
				</mask>
				<g mask="url(#mask3_267_1511)">
					<path
						d="M19.9323 39.9375V59.9792C19.9323 62.7344 22.1875 64.9896 24.9427 64.9896H49.9948V62.4844C49.9948 52.8177 57.8646 44.9479 67.5312 44.9479H75.0469V39.9375H19.9323ZM32.4583 57.474H24.9427V52.4635H32.4583V57.474ZM44.9844 57.474H37.4687V52.4635H44.9844V57.474Z"
						fill="white"
					/>
				</g>
				<mask
					id="mask4_267_1511"
					maskUnits="userSpaceOnUse"
					x="54"
					y="49"
					width="26"
					height="26">
					<path
						d="M54.6667 49.3335H79.9323V74.8179H54.6667V49.3335Z"
						fill="white"
					/>
				</mask>
				<g mask="url(#mask4_267_1511)">
					<path
						d="M67.5312 49.9585C60.6146 49.9585 55.0052 55.5731 55.0052 62.4845C55.0052 69.4012 60.6146 75.0106 67.5312 75.0106C74.4479 75.0106 80.0573 69.4012 80.0573 62.4845C80.0573 55.5731 74.4479 49.9585 67.5312 49.9585ZM66.6458 68.021L60.0052 61.3804L62.6614 58.7241L66.6458 62.7085L72.4062 56.9533L75.0625 59.6095L66.6458 68.021Z"
						fill="white"
					/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_267_1511">
					<rect width="100" height="100" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

export function CentralizedMessagingIcon() {
	return (
		<svg
			width="90"
			height="90"
			viewBox="0 0 90 90"
			fill="none"
			className="item-icon"
			xmlns="http://www.w3.org/2000/svg">
			<mask
				id="mask0_328_638"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="89"
				height="89">
				<path
					d="M0.671875 0.671875H88.6667V88.6667H0.671875V0.671875Z"
					fill="white"
				/>
			</mask>
			<g mask="url(#mask0_328_638)">
				<mask
					id="mask1_328_638"
					maskUnits="userSpaceOnUse"
					x="0"
					y="0"
					width="89"
					height="89">
					<path
						d="M44.6667 0.671875C20.3698 0.671875 0.671875 20.3698 0.671875 44.6667C0.671875 68.9688 20.3698 88.6667 44.6667 88.6667C68.9688 88.6667 88.6667 68.9688 88.6667 44.6667C88.6667 20.3698 68.9688 0.671875 44.6667 0.671875Z"
						fill="white"
					/>
				</mask>
				<g mask="url(#mask1_328_638)">
					<path
						d="M0.671875 0.671875H88.6667V88.6667H0.671875V0.671875Z"
						fill="#F6AA3A"
					/>
				</g>
			</g>
			<path
				d="M63.2417 27.0513C59.1481 22.9582 53.5963 20.6587 47.8074 20.6587C42.0185 20.6587 36.4666 22.9582 32.373 27.0513C28.9564 30.4771 26.7747 34.9409 26.1707 39.7413C25.5668 44.5418 26.5749 49.4069 29.0366 53.5721L26.4722 63.8208L36.7029 61.2624C40.8706 63.7278 45.7398 64.7374 50.5442 64.1323C55.3486 63.5272 59.8154 61.3418 63.2417 57.92C67.3349 53.8264 69.6343 48.2745 69.6343 42.4856C69.6343 36.6967 67.3349 31.1449 63.2417 27.0513Z"
				fill="white"
			/>
		</svg>
	);
}

export function BlueCheckIcon() {
	return (
		<svg
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			className="blue-check-icon"
			xmlns="http://www.w3.org/2000/svg">
			<mask
				id="mask0_0_1"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="18"
				height="18">
				<path
					d="M0.484375 0.838562H17.5156V17.8698H0.484375V0.838562Z"
					fill="white"
				/>
			</mask>
			<g mask="url(#mask0_0_1)">
				<mask
					id="mask1_0_1"
					maskUnits="userSpaceOnUse"
					x="0"
					y="0"
					width="18"
					height="18">
					<path
						d="M9 0.838562C4.29687 0.838562 0.484375 4.65106 0.484375 9.35419C0.484375 14.0573 4.29687 17.8698 9 17.8698C13.7031 17.8698 17.5156 14.0573 17.5156 9.35419C17.5156 4.65106 13.7031 0.838562 9 0.838562Z"
						fill="white"
					/>
				</mask>
				<g mask="url(#mask1_0_1)">
					<path
						d="M0.484375 0.838562H17.5156V17.8698H0.484375V0.838562Z"
						fill="#5DDFF2"
					/>
				</g>
			</g>
			<mask
				id="mask2_0_1"
				maskUnits="userSpaceOnUse"
				x="4"
				y="5"
				width="10"
				height="9">
				<path
					d="M4.16663 5.66669H13.8437V13.4063H4.16663V5.66669Z"
					fill="white"
				/>
			</mask>
			<g mask="url(#mask2_0_1)">
				<path
					d="M13.2031 5.67192C13.052 5.67192 12.9218 5.72921 12.8177 5.83858L7.03121 11.6198L5.18225 9.77087C5.07288 9.65629 4.94267 9.599 4.78642 9.599C4.62496 9.599 4.49475 9.65108 4.38017 9.76567C4.27079 9.87504 4.2135 10.0105 4.21871 10.1667C4.21871 10.323 4.276 10.4584 4.39059 10.5677L6.63538 12.8125C6.74475 12.9219 6.88017 12.9792 7.03121 12.9792C7.18746 12.9792 7.32288 12.9219 7.43225 12.8125L13.6093 6.63546C13.7916 6.45317 13.8333 6.25004 13.7343 6.01046C13.6354 5.77608 13.4583 5.6615 13.2031 5.67192Z"
					fill="white"
				/>
			</g>
		</svg>
	);
}
